"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Children = void 0;

var _variables = require("../../../global-files/variables");

var _GeneralButton = require("../../atoms/GeneralButton");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _styles = require("./styles");

var _createVersion = _interopRequireDefault(require("../../../assets/images/versionSelector/createVersion.svg"));

var _genericModalWarning = _interopRequireDefault(require("../../../assets/images/genericModal/genericModalWarning.svg"));

var _VersionSelect = require("../../atoms/Select/VersionSelect");

var _jsxRuntime = require("react/jsx-runtime");

var Children = function Children(step, setStep, versions, selectedVersions, _onChange, createVersion) {
  switch (step) {
    case "version-options":
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.VersionOptions, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _createVersion.default,
          alt: "create version icon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
          fontFamily: _variables.FontFamily.Raleway_500,
          headerType: "product-name-header",
          color: _variables.GlobalColors.white,
          text: "Crea una nueva versi\xF3n"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
          fontFamily: _variables.FontFamily.Raleway,
          headerType: "retailer-name-header",
          color: _variables.GlobalColors.white,
          text: "Puedes elegir el contenido de versiones anteriores o crear una versi\xF3n desde cero"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "buttons-container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            label: "Versi\xF3n desde cero",
            buttonType: "general-transparent-button",
            onClick: function onClick() {
              return setStep("empty-version");
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            label: "Versi\xF3n personalizada",
            buttonType: "general-default-button",
            onClick: function onClick() {
              return setStep("create-version");
            }
          })]
        })]
      });

    case "empty-version":
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.EmptyVersion, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _genericModalWarning.default,
          alt: "warning icon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
          fontFamily: _variables.FontFamily.Raleway_500,
          headerType: "product-name-header",
          color: _variables.GlobalColors.white,
          text: "Si creas una versi\xF3n desde cero perderas la informaci\xF3n actual"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
          fontFamily: _variables.FontFamily.Raleway,
          headerType: "retailer-name-header",
          color: _variables.GlobalColors.white,
          text: "\xBFDeseas Continuar?"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "buttons-container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            label: "Atr\xE1s",
            buttonType: "general-transparent-button",
            onClick: function onClick() {
              return setStep("version-options");
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            label: "Continuar",
            buttonType: "general-default-button",
            onClick: function onClick() {
              return createVersion(true);
            }
          })]
        })]
      });

    case "create-version":
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CreateVersion, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
          fontFamily: _variables.FontFamily.Raleway_500,
          headerType: "retailer-name-header",
          color: _variables.GlobalColors.white,
          text: "Elige el contenido que deseas utilizar de versiones anteriores"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "version-selector",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "selector",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VersionSelect.VersionSelect, {
              versions: versions,
              label: "Ficha t\xE9cnica",
              id: "datasheet",
              selectedVersions: selectedVersions,
              onChange: function onChange(e) {
                return _onChange(e);
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "selector",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VersionSelect.VersionSelect, {
              versions: versions,
              label: "Descripci\xF3n",
              id: "description",
              selectedVersions: selectedVersions,
              onChange: function onChange(e) {
                return _onChange(e);
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "selector",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VersionSelect.VersionSelect, {
              versions: versions,
              label: "Im\xE1genes",
              id: "image",
              selectedVersions: selectedVersions,
              onChange: function onChange(e) {
                return _onChange(e);
              }
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "buttons-container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            label: "Atr\xE1s",
            buttonType: "general-transparent-button",
            onClick: function onClick() {
              return setStep("version-options");
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            label: "Continuar",
            buttonType: "general-default-button",
            onClick: function onClick() {
              return createVersion();
            }
          })]
        })]
      });
  }
};

exports.Children = Children;